module.exports = __webpack_public_path__ + "img/header-diamondJewelryPlatinum.2cb15fe.jpg";